
<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col
              cols="12"
              md="2"
              class="mb-md-0 mb-2"
          >

            <b-form-group>
              <label>Rango de fecha</label>
              <flat-pickr
                  id="rangeFecha"
                  v-model="rangeDate"
                  class="form-control"
                  size="sm"
                  :config="{
                    mode: 'range',
                    dateFormat: 'd/m/Y',
                    defaultDate: [new Date(), new Date()],
                    locale: 'es',
                     maxDate: new Date(),

                  }"

              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="4"
              class="mb-md-0 mb-2"
          >
            <label>&nbsp;</label>
            <br>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                @click="validadEntrada"
            >
              <feather-icon
                  icon="PlusIcon"
                  class="mr-50"
              />
              <span class="align-middle">Resgistrar Fecha(s)</span>

            </b-button>
            &nbsp;
            <div v-if="show" class="spinner-border text-primary" role="status" style="width: 1.3rem; height: 1.3rem;">
            </div>

          </b-col>

        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body >
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <!-- Registar Tipo  -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-button
                variant="gradient-primary"
                size="sm"
                class="mr-1"
                @click="traerEmpresas"
            >
              <feather-icon
                  icon="RefreshCwIcon"
              />
            </b-button>

          </b-form-group>

          <!-- filter -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Buscar"
              />
              <b-input-group-append>
                <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                >
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

        </div>
      </b-card-body>

      <b-table
          hover
          responsive
          class="position-relative"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="cPaginacion"
      >
        <template #cell(estado)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>

        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon
                :id="`btn_${data.item.id}_editar`"
                icon="EditIcon"
                size="16"
                class="mx-1"
                @click="mostrarModal(2, data.item.id, data.item.nombre, data.item.estado)"
            />
            <b-tooltip
                title="Editar registro"
                :target="`btn_${data.item.id}_editar`"
            />
            <feather-icon
                :id="`btn_${data.item.id}_eliminar`"
                icon="Trash2Icon"
                size="16"
                @click="eliminarRegistro(data.item.id, data.item.cod)"
            />
            <b-tooltip
                title="Eliminar registro"
                :target="`btn_${data.item.id}_eliminar`"
            />
          </div>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>


    </b-card>
  </div>

</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      estadoModal: false,
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'codigo_fecha',
          label: 'Codigo',
          sortable: true
        },
        {
          key: 'formato_fecha_slash',
          label: 'Fecha',
          sortable: true
        },
        {
          key: 'fecha_completa_ingles',
          label: 'Fecha completa',
          sortable: true
        },
        {
          key: 'numero_year',
          label: 'Año',
          sortable: true
        },
        {
          key: 'numero_mes',
          label: 'Mes',
          sortable: true
        },
        {
          key: 'nombre_mes_spanish',
          label: 'nombre mes',
          sortable: true
        },
        {
          key: 'numero_dias_mes',
          label: 'Número día Mes',
          sortable: true
        },
        {
          key: 'periodo_mes_year',
          label: 'periodo mes-año',
          sortable: true
        },

        {
          key: 'numero_semana',
          label: 'número semana',
          sortable: true
        },
        {
          key: 'periodo_semana_year',
          label: 'periodo semana-año',
          sortable: true
        },
        {
          key: 'numero_dia_semana',
          label: 'Número día',
          sortable: true
        },
        {
          key: 'nombre_dia_semana_spanish',
          label: 'Nombre día',
          sortable: true
        },
        {
          key: 'trimistre_year',
          label: 'Trimestre',
          sortable: true
        },
        {
          key: 'numero_dia_year',
          label: 'número día año',
          sortable: true
        },

      ],
      items: [],
      status: [
        {
          1: 'Activo',
          0: 'Inactivo',
        },
        {
          1: 'light-success',
          0: 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 1, text: "Activo"},
        {value: 0, text: "Inactivo"}
      ],
      rangeDate: null,
      show:false,

      nombre: '',
      estado: {value: 1, text: "Activo"},
      id: 0,
      tipo: 0,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.traerEmpresas();
  },
  methods: {
    traerEmpresas(){
      var yo = this

      var config = {
        method: 'get',
        url: '/forecast/forecast/fechas/'
      };

      axiosIns(config)
          .then(function (response) {
            yo.items = response.data;
            yo.totalRows = yo.items.length
          })
          .catch(function (error) {
            console.log(error);
          });
    },

    validadEntrada(){
      const yo = this
      let fecha = yo.rangeDate;


      if(fecha !== null && fecha !== '') {
        let fecha_array = fecha.split(' a ')
        let fechaInicio = ''
        let fechaFin = ''
        if(fecha_array.length == 2){
          let sep_feha_in = fecha_array[0].split('/');
          let sep_feha_fin = fecha_array[1].split('/');
          fechaInicio = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0]
          fechaFin = sep_feha_fin[2]+"-"+sep_feha_fin[1]+"-"+sep_feha_fin[0]
          yo.datos_fechas(fechaInicio,fechaFin);
        }else{
          yo.$swal.fire(
              'Mensaje',
              'Debe selecionar una fecha inicial y final',
              'warning'
          ).then((result) => {
          });
        }

      }else{
        yo.$swal.fire(
            'Mensaje',
            'Debe selecionar una fecha inicial y final',
            'warning'
        ).then((result) => {
        });
      }


    },

    datos_fechas(fechaInicio,fechaFin){
      const yo = this
      var day1Inicial = new Date(fechaInicio);
      var day2Final = new Date(fechaFin);
      var difference= Math.abs(day2Final-day1Inicial);
      var days = (difference/(1000 * 3600 * 24))+1;
      if(days<=31){
        yo.abrir(fechaInicio,fechaFin);
      }else{
        yo.$swal.fire(
            'Mensaje',
            'El rango de fecha seleccionado supera los 31 días!',
            'warning'
        ).then((result) => {
        });
      }
    },

    abrir(fecha_inicial,fecha_final){

      var yo = this


      this.$swal({
        title: '¿Está seguro?',
        text: "¿Desea registrar  la fecha desde el " +fecha_inicial+ ' al '+fecha_final,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          yo.insertDataFecha(fecha_inicial,fecha_final);
          //yo.insertDataLog(12,12,12);
        }
      })

      //this.estadoModal = true;
    },
    insertDataFecha(fecha_inicial,fecha_final){

      var yo = this

      yo.show=true;
      this.$swal.fire({
        title: 'Generando...',
        text: 'Por favor espere, se está registrando la fecha(s)',
        footer: "No cierre la ventana",
        //imageUrl:'https://upload.wikimedia.org/wikipedia/commons/c/c7/Loading_2.gif?20170503175831',
        //imageUrl:"https://adhana.com/wp-content/uploads/2019/03/spinner.gif",
        //imageUrl:"http://tramites.urcuqui.gob.ec/sisplan/modulos/obtencion/imgs/loading.gif",
        imageUrl:require('@/assets/images/loading/loading.gif'),
        //imageUrl:"https://static.wixstatic.com/media/680d86_8cd61a3eedbd41fba383c945214a3508~mv2.gif",
        imageWidth: 200,
        imageHeight: 200,
        showCancelButton: false, // There won't be any cancel button
        showConfirmButton: false // There won't be any confirm button
      })

      var qs = require('qs');
      var data = qs.stringify({
        'fechaInicial': fecha_inicial,
        'fechaFinal': fecha_final
      });

      var config = {
        method: 'POST',
        url: ('/forecast/forecast/llenarRangoFecha/'),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data : data,
        timeout:false,
      };


      axiosIns(config)
          .then(function (response) {
            console.log("Ejecución exitosa");
            console.log(response.data);
            yo.show=false;
            yo.$swal.fire(
                'Success!',
                'Registro Exitoso!',
                'success'
            ).then((result) => {
              yo.traerEmpresas();

            });


          })
          .catch(function (error) {
            console.log("Error en la ejecución");
            console.log(error);

            console.log(error);
            //console.log(error.stack);
            yo.show=false;


            yo.$swal.fire(
                'Error!',
                'Problema al registrar',
                'error'
            ).then((result) => {
              yo.traerEmpresas();

            });

            /*yo.$swal.fire(
                'Generado!',
                'El ETL se Generó con éxito',
                'success'
            ).then((result) => {
              yo.listarLog();

            });
            */
          });



    },



    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },



  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
